
import store from '@/store'

export default{
  // eslint-disable-next-line
  inserted(el, binding, vnode) {
    const { value } = binding
    const roles = store.getters && store.getters.userPermission

    if (value && value instanceof Array && value.length > 0) {
      const permissionRoles = value[0]
      if (!store.getters.isAdmin && roles.indexOf('|' + permissionRoles + '|') === -1) {
        el.parentNode && el.parentNode.removeChild(el)
      }
    } else {
      throw new Error(`need roles! Like v-permission="['admin','editor']"`)
    }
  }
}
